import { useQuery } from '@tanstack/react-query';
import { getFieldTypes, getFieldApplyStatuses } from '../../api/CHAMPS/champs';

export const useGetFieldTypes = () => {
  return useQuery({
    queryKey: ['fieldTypes'],
    queryFn: getFieldTypes,
    staleTime: 1000 * 60 * 60, // 1 hour (rarely changes)
  });
};

export const useGetFieldApplyStatuses = () => {
  return useQuery({
    queryKey: ['statuts'],
    queryFn: getFieldApplyStatuses,
    staleTime: 1000 * 60 * 60, // 1 hour (rarely changes)
  });
};
